import { APICallV3Post } from 'reactApp/api/APICall';

export class R7EditApiAPICall extends APICallV3Post {
    _method = 'r7/edit';
}
